module.exports = __webpack_public_path__ + "4.jpg?06f7df16bf2a73a1493449f8cd5832b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/4.jpg
// module id = 59
// module chunks = 0